import { FC } from "react";
import { useTranslation } from "react-i18next";
import Drawer from "@mui/material/Drawer";
import KeyboardBackspaceIcon from "@mui/icons-material/KeyboardBackspace";
import Modal from "../../components/Modal";
import RulesContent from "./content";
import useScreen from "../../hooks/useScreen";

export type RulesModalProps = {
  isToggled: boolean;
  onClose: () => void;
};

const RulesModal: FC<RulesModalProps> = ({ isToggled, onClose }) => {
  const { t } = useTranslation();
  const { isDesktop } = useScreen();

  if (!isDesktop) {
    return (
      <Drawer
        anchor="bottom"
        open={isToggled}
        onClose={onClose}
        PaperProps={{ style: { height: "calc(100vh - 60px)" } }}
      >
        <div className="flex flex-col h-full">
          <div className="flex items-center bg-white border-b">
            <button onClick={onClose} className="py-3 px-5 rounded">
              <KeyboardBackspaceIcon
                className="mr-1 bg-yellow-300 rounded p-1 box-content"
                style={{ fontSize: 18 }}
              />
              {t("Back")}
            </button>
            <b className="px-2">{t("Rules and regulations")}</b>
          </div>
          <div className="overflow-y-auto p-4">
            <RulesContent />
          </div>
        </div>
      </Drawer>
    );
  }

  return (
    <Modal open={isToggled} onClose={onClose}>
      <div className="flex flex-col overflow-hidden">
        <div className="flex justify-between items-center mb-3">
          <h3 className="text-lg font-bold">{t("Rules and regulations")}</h3>
          <button
            className="text-gray-500 hover:text-gray-800 text-xl leading-none"
            onClick={onClose}
            aria-label="close"
          >
            ✕
          </button>
        </div>
        <div className="overflow-y-auto pr-2">
          <RulesContent />
        </div>
      </div>
    </Modal>
  );
};

export default RulesModal;
